/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GenerationRecordExport interface.
 */
export function instanceOfGenerationRecordExport(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function GenerationRecordExportFromJSON(json) {
    return GenerationRecordExportFromJSONTyped(json, false);
}
export function GenerationRecordExportFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'id': json['id'],
        'rating': json['rating'] == null ? undefined : json['rating'],
    };
}
export function GenerationRecordExportToJSON(json) {
    return GenerationRecordExportToJSONTyped(json, false);
}
export function GenerationRecordExportToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdAt': value['createdAt'],
        'id': value['id'],
        'rating': value['rating'],
    };
}
